'use strict';

/* eslint-disable */

// const Swiper = require('swiper/swiper-bundle.cjs');

let layout = require('./layout'),
    defaultOptions = Resources.CAROUSEL_CINFIG,
    initialized = false,
    $cache = {},
    options = {},
    selectors = {
        containerTitleSelector: '.js-carousel-title'
    };

/**
 * @description Checks if carousel should be enabled on current screen size
 *
 * @param {Object} carouselOptions
 * @returns {Boolean}
 */
function isDisabledOnCurrentDevice(carouselOptions) {
    return carouselOptions['disableOnDevices'] && carouselOptions['disableOnDevices'].indexOf(layout.getMode()) !== -1;
}

/**
 * @description Checks if all slides are visible, if not, means we need to init carousel
 *
 * @param {jQuery} $swiper
 * @param {Object} carouselOptions
 * @returns {Boolean}
 */
function hasSlidesToScroll($swiper, carouselOptions) {
    let currentBreakpointWidth = layout.getCurrentBreakpointWidth();
    let slidesPerView = carouselOptions.slidesPerView || 1;
    if (carouselOptions.breakpoints &&
        carouselOptions.breakpoints[currentBreakpointWidth] &&
        carouselOptions.breakpoints[currentBreakpointWidth].slidesPerView) {
        slidesPerView = carouselOptions.breakpoints[currentBreakpointWidth].slidesPerView;
    }

    let slidesCount = $swiper.find('.swiper-slide:not(.swiper-slide-duplicate)').length;

    return slidesPerView < slidesCount;
}

/**
 * @description Checks if carousel has slides
 *
 * @param {jQuery} $swiper
 * @returns {Boolean}
 */
function hasSlides($swiper) {
    let slidesCount = $swiper.find('.swiper-slide:not(.swiper-slide-duplicate)').length;

    return slidesCount > 0;
}

/**
 * @description if autoplay enabled for carousel, we need to attach pause on mouseenter event
 *
 * @param {jQuery} $swiper
 * @param {Object} swiperInstance
 * @param {Object} carouselOptions
 * @param {Boolean} detachEvents, if set to false, will detach events, this is needed after swiper destroy and before re-initialization
 *
 * @returns {Void}
 */
function autoplayHandler($swiper, swiperInstance, carouselOptions, detachEvents) {
    if (!swiperInstance || !swiperInstance.autoplay || !carouselOptions.autoplay) {
        return;
    }

    if (detachEvents) {
        $swiper.off('mouseenter');
        $swiper.off('mouseleave');
    } else {
        $swiper.on('mouseenter', () => {
            swiperInstance.autoplay.stop();
        });
        $swiper.on('mouseleave', () => {
            swiperInstance.autoplay.start();
        });
    }
}

function initCarouselEvents($swiper, swiperInstance, carouselOptions, attachEvents) {
    autoplayHandler($swiper, swiperInstance, carouselOptions, attachEvents);

    swiperInstance
        .on('slideNextTransitionStart', function () {
            $swiper.find('.swiper-wrapper').addClass('swiper-next-clicked');
        })
        .on('slidePrevTransitionStart', function () {
            $swiper.find('.swiper-wrapper').removeClass('swiper-next-clicked');
        })
        .on('touchEnd', function () {
            $(document).trigger('swiperslideChangeTransitionEnd');
        });
}

function initCarousel() {
    var $swiper = $(this),
        swiperDOMNode = $swiper[0],
        swiperInstance = $swiper[0] && $swiper[0].swiper,
        carouselType = $swiper.data('carouselType'),
        inlineOptions = $swiper.data('carouselOptions'),
        carouselOptions = {};

    carouselOptions = $.extend({}, options, defaultOptions[carouselType] || {});

    if (inlineOptions) {
        carouselOptions = $.extend(carouselOptions, inlineOptions);
    }

    if (hasSlides($swiper)) {
        $swiper.removeClass('is--hidden');
        $swiper.find(selectors.containerTitleSelector).removeClass('is--hidden');
    }

    // if carousel has customClass for height on different devices
    if(carouselOptions.customClass) {
        if (typeof carouselOptions.customClass === 'object') {
            let allowedKeys = ['mobile', 'tablet', 'desktop'];
            for (let i of allowedKeys) {
                if (carouselOptions.customClass.hasOwnProperty(i) && carouselOptions.customClass[i]) {
                    $swiper.find('.swiper-wrapper').addClass(carouselOptions.customClass[i]);
                }
            }
        } else {
            $swiper.find('.swiper-wrapper').addClass(carouselOptions.customClass);
        }
    }
    $swiper.removeClass('init-height-0');

    if (isDisabledOnCurrentDevice(carouselOptions) ||
        $swiper.closest('.hidden').length > 0 ||
        !hasSlidesToScroll($swiper, carouselOptions)) {
        if (swiperInstance && swiperInstance.initialized) {
            swiperDOMNode.swiper.destroy(swiperDOMNode, true);
        }
        $swiper.addClass('carousel-disabled');
        $swiper.find(carouselOptions.navigation.nextEl).addClass(carouselOptions.navigation.disabledClass);
        $swiper.find(carouselOptions.navigation.prevEl).addClass(carouselOptions.navigation.disabledClass);
        return;
    } else {
        $swiper.removeClass('carousel-disabled');
    }

    if (swiperInstance) {
        if (carouselOptions.destroyOnModeChange) {
            swiperDOMNode.swiper.destroy(swiperDOMNode, true);
            initCarouselEvents($swiper, swiperInstance, carouselOptions, true);
        } else {
            swiperInstance.update();
            return;
        }
    }

    swiperInstance = new Swiper.default(swiperDOMNode, carouselOptions);
    initCarouselEvents($swiper, swiperInstance, carouselOptions);
}

function initAllCarousels() {
    $(this)
        .find(options.containerSelector)
        .each(initCarousel);
}

function initializeParams(params) {
    options = $.extend(true, {}, defaultOptions['default'], params);
}

function initializeCache() {
    $cache.document = $(document);
}

function initializeEvents() {
    $cache.document
        .on('search.updated', function(event, $container) {
            $container
                .find(options.containerSelector)
                .each(initCarousel);
        })
        .on('init.carousel.byselector', function(event, selector) {
            initCarousel.call($(selector));
        })
        .on('recommendations.loaded recommendations.initPredictiveRecommendations', function(event, selector) {
            initAllCarousels.call(selector);
        })
        .on('init.all.carousels.insideselector', function(event, selector) {
            initAllCarousels.call(selector);
        })
        .on('window.modechanged recommendations.initPredictiveRecommendations', function() {
            $cache.document
                .find(options.containerSelector)
                .each(initCarousel);
        });
}

module.exports = {
    init: function(params) {
        initializeParams(params);

        if (initialized) { return; }

        initializeCache();
        initializeEvents();
        initAllCarousels.apply(options.container || document);
        initialized = true;
    }
};
